import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
var Ellipsis = function Ellipsis(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style;
  return _jsx("div", Object.assign({
    className: classnames('by-ellipsis', className),
    style: style
  }, {
    children: children
  }));
};
Ellipsis.defaultProps = {
  rows: 1
};
Ellipsis.displayName = 'Ellipsis';
export default Ellipsis;